import { computed } from 'vue'
import { useImpersonateStore } from '~/stores/impersonate'
import { useUserStore } from '~/stores/useUserStore'

export function useCustomerContextKey() {
  const userStore = useUserStore()
  const impersonateStore = useImpersonateStore()

  return computed(() => {
    if (impersonateStore.isImpersonating && impersonateStore.impersonatedCustomerId) {
      return `impersonating:${impersonateStore.impersonatedCustomerId}`
    }

    return `own:${userStore.customerId ?? 'none'}`
  })
}
